import { render, staticRenderFns } from "./Page9.vue?vue&type=template&id=24f66ddb&scoped=true&"
import script from "./Page9.vue?vue&type=script&lang=js&"
export * from "./Page9.vue?vue&type=script&lang=js&"
import style0 from "./Page9.vue?vue&type=style&index=0&id=24f66ddb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f66ddb",
  null
  
)

export default component.exports